module.exports = __webpack_public_path__ + "img/center-bg-2.1e756e1a.png";